import * as React from 'react';
import { FailedOrdersTable } from '..';
import { Table, NotificationBox } from '../../CommonUI';
import { FailedOrders as FailedOrdersModel } from '../../Model';
import { Flex } from '../../CommonUI/Layout';

interface FailedOrdersProps {
    source: string;
    syncedOrders: number;
    unsyncedOrders: number;
    failedOrders: FailedOrdersModel[];
    onChange: (message: string) => void;
    notification?: boolean;
    onNotificationClose?: () => void;
    tierName: string;
}

export class FailedOrders extends React.Component<FailedOrdersProps> {
    constructor(props: FailedOrdersProps) {
        super(props);
        this.onSync = this.onSync.bind(this);
    }

    public onSync() {
        this.props.onChange('resync');
    }

    public base64Decode(str: string) {
        return decodeURIComponent(Array.prototype.map.call(atob(str), (c: string) => {
            return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
        }).join(''));
    }

    public decodeFailedOrders() {
        return this.props.failedOrders.map((order) => {
            return {
                referenceId: order.referenceId,
                error: this.base64Decode(order.error),
            };
        });
    }

    public render() {
        const { syncedOrders, unsyncedOrders, failedOrders, source, notification, onNotificationClose, tierName } = this.props;
        const pageSize = 20;
        const showPagination = failedOrders.length > pageSize;
        return (
            <Flex alignItems={'left'} flexDirection={'column'}>
                {notification
                    ? <NotificationBox text="pastOrders.notification" onClick={onNotificationClose}/>
                    : ''
                }
                <FailedOrdersTable
                    syncedCount={syncedOrders}
                    failedCount={unsyncedOrders}
                    onSync={this.onSync}
                    source={source}
                    tierName={tierName}
                />
                {(failedOrders.length > 0)
                    ? <Table
                        id="error-table"
                        label="pastOrders.ordersUnsyced"
                        cols={[
                            {label: 'pastOrders.referenceNo', accessor: 'referenceId', width: 200},
                            {label: 'pastOrders.typeOfTheError', accessor: 'error'}
                        ]}
                        data={this.decodeFailedOrders()}
                        showPagination={showPagination}
                        defaultPageSize={showPagination ? pageSize : failedOrders.length}
                    />
                    : ''
                }
            </Flex>
        );
    }
}



// WEBPACK FOOTER //
// ./src/Components/PastOrders/FailedOrders.tsx